import { DrawRoofForPanel } from './panel/drawRoofForPanel';

export class ScaleAdjustmentValue {
    // to add scale at top and left side of canvas taken gap by adding 100
    // while drawing canvas this function helps to adding gap so we can work with original X,Y co-ordinates
    static initValue: number = 100;
    static getScaleAdjust (value : number) {
        
        return 100 +  parseFloat(value.toFixed(2));
    }
    // parseFloat(value.toFixed(2));
    static getOriginalbyRemovingStarting(value: number){
        return (parseFloat(value.toFixed(2))) - this.initValue;
    }
    static getOriginalValue(value: number){
        return this.reverseScale(parseFloat(value.toFixed(2))) - 100;
    }
    static getOriginalValuewithoutStarting(value: number){
        return this.reverseScale(parseFloat(value.toFixed(2))) - 100;
    }
    static getOriginalValueWithOutScale(value: number){
        return (parseFloat(value.toFixed(2))) - 100;
    }
    static getOriginalValueWithOutScaleWithoutStartingPoint(value: number){
        return (parseFloat(value.toFixed(2))) ;
    }
    static getOriginalValueWithoutStartingPoint(value: number){
        return this.reverseScale(parseFloat(value.toFixed(2)) - 100);
    }

    static reverseScale(value: number) {
        //console.log('DrawRoofForPanel.currentScale in reverseScale',value,DrawRoofForPanel.currentScale,value * 1 / DrawRoofForPanel.currentScale);
        return value * 1 / DrawRoofForPanel.currentScale
    }

    static getPanelRows(rows: any, api?: boolean): any { 
        rows.forEach((item: any)=>{
            // console.log(item.x)
            if(api) {
                item.x += 100;
                item.y += 100;
            } else {
                item.x -= 100;
                item.y -= 100;
            }
        });
        // console.log(rows)
        return rows;
    }
}